export type ParsedNotificationMessage = {
  title: string
  description?: string
}

/** Split API `message` into title + optional description for panel layout */
export function parseNotificationMessage(message: string): ParsedNotificationMessage {
  const trimmed = message.trim()
  if (!trimmed) return { title: '' }

  const lines = trimmed
    .split(/\n+/)
    .map((line) => line.trim())
    .filter(Boolean)

  if (lines.length >= 2) {
    return { title: lines[0], description: lines.slice(1).join(' ') }
  }

  const emDash = ' — '
  const dashIndex = trimmed.indexOf(emDash)
  if (dashIndex !== -1) {
    return {
      title: trimmed.slice(0, dashIndex).trim(),
      description: trimmed.slice(dashIndex + emDash.length).trim(),
    }
  }

  return { title: trimmed }
}
